import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { _generateRoute } from '@/utils/generateRouter'
import './assets/style/base.scss'
import './assets/style/scroll.scss'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI);

//全局路由钩子

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
